/* IBM Confidential‌ - OCO Source Materials‌ - (C) COPYRIGHT IBM CORP. 2022 - The source code for this program is not published or otherwise‌ divested of its trade secrets, irrespective of what has been‌ deposited with the U.S. Copyright Office. */

// this is a react component that encapsulates the username and password form .
// It uses the authentactionservice to autheticate with tririga and then
// pushes the session token to the local sessionStorage.

import React from 'react';
import "../login-form/LoginForm.scss";
import { AuthenticationService } from '../service/AuthenticationService';

import { Button, Form, TextInput } from 'carbon-addons-iot-react';
import { ArrowRight32 } from '@carbon/icons-react';
import { InlineNotification } from "carbon-components-react";
import { AppMsg } from "../utils";

export class ChangePwdForm extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            oldPassword: '',
            newPassword: '',
            confirmNewPassword: '',
            errorMessage: '',
            disableContinue: true,
            height: window.innerHeight
        }
        this.textInputRef = null;
    }

    _setOldPassword(pwd) {
        this.setState({
            oldPassword: pwd
        }, () => { this._validateInputFields() });
    }

    _setNewPassword(pwd) {
        this.setState({
            newPassword: pwd
        }, () => { this._validateInputFields() });
    }

    _setConfirmNewPassword(pwd) {
        this.setState({
            confirmNewPassword: pwd
        }, () => { this._validateInputFields() });
    }

    _validateInputFields() {
        //if username and password fields are not empty then enable continue button
        if (this.state.oldPassword !== '' && this.state.newPassword !== '' && this.state.confirmNewPassword !== '' && 
            this.state.newPassword === this.state.confirmNewPassword && 
            this.state.errorMessage === '') {
            this.setState({
                disableContinue: false
            });
        } else {
            this.setState({
                disableContinue: true
            });
        }
    }

    _enableContinueButton() {
        this.setState({
            errorMessage: ''
        }, () => { this._validateInputFields() });
    }

    handleSubmit(event) {
        event.preventDefault();
        AuthenticationService.changePassword(this.props.username, 
                                            this.state.oldPassword, 
                                            this.state.newPassword,
                                            this.state.confirmNewPassword).then(
            () => {
                this.props.showPwdSuccessfulLoginForm();
            },
            error => {
                this.setState({
                                errorMessage: error,
                                disableContinue: true
                            });
            }
        );
    }

    _handleAutofill(e) {
        if (e.animationName === "onAutoFillStart") {
            console.log('Auto Fill Detected');
            //This will fail if only user name is filled by browser and empty password
            this._enableContinueButton();
        }
    }

    componentDidMount() {
        window.addEventListener('resize', this.handleResize);
    }
    
    componentWillUnmount(){
        window.removeEventListener('resize', this.handleResize);
    }
    
    handleResize = () => {
       this.setState({height: window.innerHeight});
    };

    render() {
        return (
            <div className="login-main-wrapper" style={{ height: this.state.height }} >
                <div className='login-wrapper'>
                    <div className="login-header">
                        <div>
                            <label>{AppMsg.getMessage(AppMsg.APP_PASSWORD_CHANGE_REQUIRED)}</label>
                        </div>
                    </div>
                    <hr className='horizontal-line' />
                    <Form onSubmit={this.handleSubmit.bind(this)}>
                        <div>
                        <TextInput
                                labelText={AppMsg.getMessage(AppMsg.APP_OLD_PASSWORD)}
                                id='oldPassword'
                                placeholder="Enter old password"
                                type="password"
                                onChange={(e) => this._setOldPassword(e.target.value)} />
                        </div>
                        <div>
                            <TextInput
                                labelText={AppMsg.getMessage(AppMsg.APP_NEW_PASSWORD)}
                                id='newPassword'
                                placeholder="Enter new password"
                                type="password"
                                onChange={(e) => this._setNewPassword(e.target.value)} />
                        </div>
                        <div>
                            <TextInput
                                labelText={AppMsg.getMessage(AppMsg.APP_CONFIRM_NEW_PASSWORD)}
                                id='confirmNewPassword'
                                placeholder="Confirm new password"
                                type="password"
                                onChange={(e) => this._setConfirmNewPassword(e.target.value)} />
                        </div>
                        <div>
                            <Button
                                kind="primary"
                                size="field"
                                renderIcon={ArrowRight32}
                                onClick={(e) => {this.handleSubmit(e)}}
                                type="submit"
                                disabled={this.state.disableContinue}>
                                {AppMsg.getMessage(AppMsg.APP_CONTINUE)}
                            </Button>
                        </div>
                    </Form>
                    {this.state.errorMessage ?
                        <div>
                            <InlineNotification
                                hideCloseButton={false}
                                iconDescription="close"
                                kind="error"
                                notificationType="inline"
                                onCloseButtonClick={() => this._enableContinueButton()}
                                role="alert"
                                statusIconDescription=""
                                subtitle={this.state.errorMessage}
                                title="Error" />
                        </div> : ''
                    }
                </div>
            </div>
        );
    }
}

export default ChangePwdForm;